export const getTodos = (state) => state.todos.items
export const getFilter = (state) => state.filter.filter
